<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <!-- <b-button
              class="mr-2"
              v-b-tooltip.hover
              size="sm"
              title="跟踪运单"
              variant="outline-secondary"
              @click="$emit('openLogDialog', row.waybillCode)"
            >
              <b-icon-cursor></b-icon-cursor>
            </b-button> -->
            <el-tooltip
              class="item"
              effect="dark"
              content="跟踪运单"
              placement="top"
            >
              <i
                class="el-icon-position tool-btn"
                @click="$emit('openLogDialog', row.waybillCode)"
              ></i>
            </el-tooltip>

            <!-- <b-button
              v-b-tooltip.hover
              v-allow="'actModify'"
              class="mr-2"
              size="sm"
              title="新增状态"
              variant="outline-secondary"
              @click="$emit('openLogEditDialog', row.waybillCode)"
            >
              <b-icon-plus></b-icon-plus>
            </b-button> -->
            <el-tooltip
              class="item"
              effect="dark"
              content="新增状态"
              placement="top"
            >
              <i
                class="el-icon-plus tool-btn"
                 @click="$emit('openLogEditDialog', row.waybillCode)"
              ></i>
            </el-tooltip>

          </b-button-group>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
    }
  },
}
</script>
